import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

interface Props {
  dominantColor?: string;
  imgSrc: string;
  ariaLabel: string;
  forceSquare?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    thumb: {
      borderRadius: theme.borderRadius[100],
      height: 0,
      paddingTop: theme.mediaRatios.oneOne,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundColor: theme.colors.bgLight,
    },
    thumbResponsive: {
      [theme.breakpoints.up('md')]: {
        paddingTop: theme.mediaRatios.sixteenNine,
      },
    },
  })
);

const ThumbImage: React.FunctionComponent<Props> = ({
  dominantColor,
  imgSrc,
  ariaLabel,
  forceSquare,
}) => {
  const classes = useStyles();

  const style = {
    backgroundImage: `url(${imgSrc})`,
    backgroundColor: dominantColor,
  };

  return (
    <div
      className={clsx(classes.thumb, { [classes.thumbResponsive]: !forceSquare })}
      role="img"
      aria-label={ariaLabel}
      style={style}
      data-testid="business-image"
    />
  );
};

export default ThumbImage;
